import { watch } from "vue";
import { isNil } from "lodash";
import { storeToRefs } from "pinia";

/**store strat */
import useGroupStore from "@/store/group";
import { useUserStore } from "@/store/user";
import { TempRecordType, useTempRecordStore } from "@/store/tempRecord";
/**store end */

import { closeModalById, openModal } from "@/utils/modal";
import GroupExpirePop from "@/NotRegisterComponents/group/GroupExpirePop.vue";
import { useRoute } from "vue-router";
import GroupRetainPop from "@/NotRegisterComponents/group/GroupRetainPop.vue";
/**
 *   团队过期弹窗逻辑（占位实现）
 * - 仅在团队模式下启用
 * - 页面加载完成后识别团队是否过期
 * - 区分管理员与普通成员，调用统一的占位弹窗逻辑（后续由你补充具体交互）
 */
export function useGroupExpirePopup() {
  const userStore = useUserStore();
  const groupStore = useGroupStore();
  const tempRecordStore = useTempRecordStore();
  const route = useRoute();

  const { groupState, isExpired, isUnnormal, isSuperAdmin } = storeToRefs(groupStore);
  const SHOWN_KEY = "useGroupExpirePopup";

  // 统一的占位弹窗行为，后续由你补充具体 UI 和交互逻辑
  function showGroupExpirePopupPlaceholder() {
    openModal(GroupExpirePop.modalId, {
      component: GroupExpirePop,
      props: {
        onClose: () => {
          closeModalById(GroupExpirePop.modalId);
        }
      }
    });

    tempRecordStore.setRecord(SHOWN_KEY, { popupId: GroupExpirePop.modalId }, TempRecordType.GLOBAL_ONCE);
  }

  function showNeedGroupRetainPopupPlaceholder() {
    openModal(GroupRetainPop.modalId, {
      component: GroupRetainPop,
      props: {
        onClose: () => {
          closeModalById(GroupRetainPop.modalId);
        }
      }
    });
  }

  // 过期判断（简化版）：优先使用明确的布尔字段，提高准确性与可维护性
  function isGroupExpired(): boolean {
    const expiredFlag = groupState.value?.expire;
    return typeof expiredFlag == "boolean" ? expiredFlag : false;
  }

  watch(
    () => isExpired.value,
    (state) => {
      if (isNil(state) || !userStore.isGroupLogin) return;
      if (isGroupExpired()) {
        if (!tempRecordStore.hasRecord(SHOWN_KEY)) {
          showGroupExpirePopupPlaceholder();
        }
      } else if (!!userStore.userInfo.uniqueId) {
        tempRecordStore.removeRecord(SHOWN_KEY);
      }
    },
    { immediate: true }
  );

  watch(
    () => route.name,
    (oldname) => {
      if (!oldname) return;
      if (!!isUnnormal.value && isSuperAdmin.value) {
        showNeedGroupRetainPopupPlaceholder();
      }
    },
    { immediate: true, flush: "post" }
  );
}
